<style scoped lang="less">
.choiostitle {
	display: flex;
	padding: 0.8rem 0.4rem;
	align-items: center;
	justify-content: space-between;
	background-color: #fff;
	margin-bottom: 1rem;
	border-left: 4px solid #38b346;

	.choiostitleleft {
		padding: 0.5rem;
		font-size: 0.8rem;
		border-radius: 50%;
		color: #fff;
		background-color: #38b346;
		border: 1px solid;
		text-align: left;
		margin-left: 0.6rem;
		box-sizing: border-box;

		span {
			font-weight: 900;
			font-size: 1.2rem;
		}
	}

	.choiostitleright {
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}

	.choiostitlelefts {
		display: flex;
		align-items: center;
	}
	.chiocetext {
		display: flex;
		margin-left: 20px;
		font-size: 16px;
		align-items: center;

		.chiocetextlist {
			display: flex;
			align-items: center;
			p {
				margin: 0 10px;
				cursor: pointer;
			}

			.avtives {
				color: #fff;
				padding: 5px 10px;
				background-color: #38b346;
				border-radius: 5px;
			}
		}
	}
}

.errlist {
	border-top: 2px solid #38b346;
	padding: 20px 10px;
	background-color: #fff;
}

/deep/ .el-collapse-item__header {
	background-color: #eff2fa;
}
/deep/ .is-active {
	background-color: #71acfe;
	color: #fff;
	.titletextdas {
		p {
			color: #fff;
		}
	}
}

.titletextdas {
	display: flex;
	align-items: center;
	margin-left: 10px;

	p {
		margin-left: 10px;
		font-size: 15px;
	}
}

.textdas {
	margin: 10px 0;
	margin-left: 80px;

	.textlisg {
		font-size: 16px;
	}

	.analyze {
		display: flex;
		justify-content: space-between;
		font-size: 15px;
		align-items: center;

		div {
			display: flex;
			align-items: center;
			cursor: pointer;
			margin-right: 40px;

			p {
				margin: 0 10px;
				font-size: 16px;
				text-decoration: underline;
			}
		}
	}
}

.elpagian {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 40px 0;
}

.courselist {
	display: flex;
	align-items: center;
	flex-wrap: wrap;

	background-color: #fff;
	padding: 20px;

	.courseitem {
		width: 19%;
		border: 1px solid #ccc;
		padding-bottom: 20px;
		margin-right: 10px;
		margin-top: 20px;
		img {
			width: 100%;
			height: 200px;
		}

		.card-text {
			width: 25%;
		}

		.courseitemcontent {
			padding: 0 10px;
			p:first-child {
				color: #4081b8;
				font-size: 18px;
			}
			p {
				font-size: 16px;
				margin: 10px 0;
			}

			.btnsgo {
				display: flex;
				align-items: center;
				justify-content: space-between;
				.btngo {
					width: 30%;
					border: 1px solid;
					text-align: center;
					height: 30px;
					line-height: 30px;
					border-radius: 5px;
					color: #fff;
					background-color: #59a959;
					cursor: pointer;
				}
			}
		}
	}
}
</style>
<template>
	<div>
		<titles titlename="我的收藏" titlecontent="这里可以看到我的收藏一些信息" :mbx="paths"></titles>
		<div class="choiostitle">
			<div class="choiostitlelefts">
				<button class="choiostitleleft "><span class="el-icon-wallet"></span></button>
				<div class="chiocetext">
					<p>收藏类型：</p>
					<div class="chiocetextlist">
						<p
							:class="{ avtives: isactivve == 0 }"
							@click="
								isactivve = 0;
								changetextli();
							"
						>
							课程
						</p>
						<p
							:class="{ avtives: isactivve == 1 }"
							@click="
								isactivve = 1;
								changetextli();
							"
						>
							试题
						</p>
					</div>
				</div>
			</div>
		</div>
		<div class="courselist" v-if="isactivve == 0">
			<el-empty style="width: 100%;" v-if="courslist.length == 0" description="暂无课程"></el-empty>

			<div class="courseitem" v-for="(item, index) in courslist" :key="item.CO_GUID">
				<img v-if="item.CO_CoverImgUrl" :src="item.CO_CoverImgUrl" alt="" srcset="" />
				<img v-else src="http://www.hngtsd.net:9999/images/ykc/ykc1.png" alt="" srcset="" />
				<div class="courseitemcontent">
					<p>{{ item.CO_CoursesName }}</p>
					<p>学习进度</p>
					<div><el-progress text-color="#fff" status="success" :text-inside="true" :stroke-width="26" :percentage="item.GT_StudyProgress"></el-progress></div>
					<p style="background: #efae43;" class="card-text text-grey-d1 mt-2 color_red">
						<span class="badge bgc-warning brc-warning text-white badge-xm arrowed arrowed-in-right">课时：{{ item.CO_Learning }}</span>
					</p>

					<div class="btnsgo">
						<el-popconfirm
							@confirm="removecourse(item)"
							confirm-button-text="好的"
							cancel-button-text="不用了"
							icon="el-icon-info"
							icon-color="red"
							title="确定取消收藏该课程吗？"
						>
							<p slot="reference" style="color: #ccc;font-size: 14px;cursor: pointer;">取消收藏</p>
						</el-popconfirm>
						<div class="btngo" @click="goexasmin(item)">进入学习</div>
					</div>
				</div>
			</div>
		</div>

		<div class="errlist" v-if="isactivve == 1">
			<el-empty v-if="lists.length == 0" description="暂无题目"></el-empty>
			<el-collapse accordion>
				<el-collapse-item v-for="(item, index) in lists" :key="item.CW_GUID" style="margin: 10px 0;">
					<template slot="title">
						<div class="titletextdas">
							<el-tag effect="dark" :type="item.SQT_Name == '单选题' ? 'warning' : item.SQT_Name == '多选题' ? 'success' : ''">{{ item.SQT_Name }}</el-tag>
							<p>{{ index + 1 }}、{{ item.SQB_Question }}</p>
						</div>
					</template>
					<div class="textdas">
						<p class="textlisg" v-for="(its, idx) in item.Questionoptions" :key="its.SQO_GUID">
							<el-radio disabled v-model="radio"></el-radio>
							{{ its.SQO_OptionName }}
						</p>

						<div style="font-size: 15px;color:rgb(0, 0, 255);">
							<span style="color: #000;">标准答案：</span>
							{{ getisanswer(item.Questionoptions) }}
						</div>

						<div class="analyze">
							<p>解析：{{ item.SQB_QuestionParsing }}</p>
							<div>
								<!-- <p @click="chengesc(item.IsMyCollect, item.SQB_GUID)">
									<span v-if="!item.IsMyCollect" class="el-icon-star-off"></span>
									<span v-if="item.IsMyCollect" style="font-size: 18px;color: #f59a23;" class="el-icon-star-on"></span>
									{{ item.IsMyCollect ? '取消收藏' : '收藏题目' }}
								</p>
								<el-popconfirm
									confirm-button-text="好的"
									cancel-button-text="不用了"
									icon="el-icon-info"
									icon-color="red"
									title="这是一段内容确定删除吗？"
									@confirm="delecttext(item.SQB_GUID)">
									<p slot="reference">
										<span style="color: red;" class="el-icon-delete-solid"></span>
										移除错题集
									</p>
								</el-popconfirm> -->
							</div>
						</div>
					</div>
				</el-collapse-item>
			</el-collapse>
		</div>

		<div class="elpagian">
			<el-pagination
				@current-change="changecurr"
				background
				hide-on-single-page
				layout="prev, pager, next"
				:page-size="pagesobj.pageSize"
				:total="totalall"
				:current-page="pagesobj.pageIndex"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';

import { GetCollectWroteLists, GetMyCollectList, DelColCourses } from '@/request/api/homesview/yunhomes/yunhom.js';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			radio: '',
			textlists: [
				{
					SQT_GUID: 0,
					SQT_Name: '所有'
				}
			],
			isactivve: 0,
			// 标题
			paths: [
				{
					path: '/usercenter/Mycolle',
					name: '我的收藏'
				}
			],
			input: '',
			totalall: 100,
			pagesobj: {
				pageSize: 10,
				pageIndex: 1,
				SQT_GUID: '',
				Inspectionlevel: '',
				PR_GUID: '',
				ProfessionalID: '',
				CourseName: '',
				kc_jd: ''
			},
			lists: [],
			courslist: []
		};
	},
	mounted() {
		this.getcourslist();
	},
	created() {
		AppOptions.appEmpty = false;
	},
	methods: {
		goexasmin(itm) {
			this.$router.push('/cours/clouddetea?coguid=' + itm.CO_GUID);
		},
		// 取消收藏
		removecourse(item) {
			let coguid = {
				CO_GUID: item.CO_GUID
			};
			DelColCourses(coguid).then(res => {
				if (res.data.code > 0) {
					this.$message.success(res.data.msg);
					this.getcourslist();
				}
			});
		},
		getisanswer(list) {
			let OptionName = list.find(its => its.SQO_IsAnswer).SQO_OptionName;
			// console.log(OptionName)
			return OptionName;
		},
		changetextli() {
			if (this.isactivve == 1) {
				this.getlist();
			} else {
				this.getcourslist();
			}
		},
		getcourslist() {
			GetCollectWroteLists(this.pagesobj).then(res => {
				if (res.data.code > 0) {
					this.courslist = res.data.data.list;
					this.totalall = res.data.data.totalCount;
				}
			});
		},

		changecurr(val) {
			this.pagesobj.pageIndex = val;
			if (this.isactivve == 1) {
				this.getlist();
			} else {
				this.getcourslist();
			}
		},
		getlist() {
			GetMyCollectList(this.pagesobj).then(res => {
				if (res.data.code > 0) {
					this.lists = res.data.data.list;
					this.totalall = res.data.data.totalCount;
				}
			});
		}
	},
	components: {
		titles
	}
};
</script>
